/* eslint-disable max-classes-per-file */
/* eslint-disable default-case */
import React from 'react';
import {PopupDialog} from 'app/utils/modals/PopupDialog';
import LogIn from 'app/components/auth/log_in';
import FastRegistrationDescription from 'app/components/auth/FastRegistrationDescription';
import FastRegistrationHeader from 'app/components/auth/FastRegistrationHeader';
import ForgotPassword from './forgot_password';
import BannedInformation from './BannedInformation';
import logEvent from 'app/amplitude/log_event';
import {iOSDevice, isDesktop} from 'app/utils';
import {KEY_ENTER} from 'app/utils/Consts';
import FastRegistrationHaveAccount from 'app/components/auth/FastRegistrationHaveAccount';
import FastRegistrationWithEmailContent from 'app/components/auth/FastRegistrationWithEmailContent';
import {pushAnalyticsEvent} from 'app/utils/analytics';

class DefaultAuthPopup extends React.PureComponent {
    static clearFiledError(component, e) {
        if (e.key !== KEY_ENTER) {
            component.setState({error: null});
        }
    }

    constructor(props) {
        super(props);
        this.activeLink = this.activeLink.bind(this);
        this.changeTab = this.changeTab.bind(this);
        this.renderForm = this.renderForm.bind(this);
    }

    toggleHasAccount = () => {
        if (this.state.selectedTab === 'login') {
            pushAnalyticsEvent('registration_start', {
                placement: this.props.usingOnTab || 'auth_popup_toggle',
                selected_tab: 'sign_up'
            });
            this.setState({selectedTab: 'sign_up'});
        } else {
            this.setState({selectedTab: 'login'});
        }
    };

    activeLink(tab) {
        return tab === this.state.selectedTab ? ' active-link' : '';
    }

    changeTab(tab, e) {
        e.preventDefault();
        this.setState({selectedTab: tab});
    }

    changeTabToForgotten = e => this.changeTab('forgotten', e);

    changeTabToBanned = () => this.setState({selectedTab: 'banned'});

    changeTabToLogin = e => this.changeTab('login', e);

    renderForm() {
        const {selectedTab} = this.state;
        const {redirectUrl} = this.props;

        switch (selectedTab) {
        case 'login':
            return <>
                <FastRegistrationHeader headerLogin/>
                <div className="tabs__content">
                    <LogIn
                        forgotPassword={this.changeTabToForgotten}
                        changeTabToBanned={this.changeTabToBanned}
                        redirectUrl={redirectUrl}
                    />
                    <FastRegistrationHaveAccount
                        hasAccount={false}
                        onClick={this.toggleHasAccount}
                    />
                </div>
            </>;
        case 'sign_up':
            return <>
                <FastRegistrationHeader headerImage/>
                <div className="tabs__content">
                    <FastRegistrationWithEmailContent/>
                    <FastRegistrationHaveAccount
                        hasAccount={true}
                        onClick={this.toggleHasAccount}
                    />
                </div>
            </>;
        case 'banned':
            return <>
                <FastRegistrationHeader headerLogin/>
                <div className="tabs__content">
                    <BannedInformation onBackClick={this.changeTabToLogin} />
                </div>
            </>;
        case 'forgotten':
            return <>
                <FastRegistrationHeader headerLogin/>
                <div className="tabs__content">
                    <ForgotPassword back={this.changeTabToLogin} />
                </div>
            </>;
        }
    }
}

export class RegistrationPopupNew extends DefaultAuthPopup {
    constructor(props) {
        super(props);
        this.state = {
            iOSDevice: iOSDevice(),
            selectedTab: this.props.selectedTab || 'sign_up'
        };
    }

    componentDidMount = () => {
        logEvent('JOIN_PAGE_VISIT', {SOURCE: this.props.usingOnTab});
    };

    render() {
        return <PopupDialog id={this.props.popupId} setFocus>
            <div className="popup__content popup__content_registration">
                <div className="tabs">
                    {this.renderForm()}
                </div>
                {isDesktop() && <FastRegistrationDescription/>}
            </div>
        </PopupDialog>;
    }
}

export class Auth extends DefaultAuthPopup {
    constructor(props) {
        super(props);
        this.state = {selectedTab: this.props.selectedTab || 'login'};
    }

    render() {
        return <PopupDialog id={this.props.popupId} setFocus>
            <div className="popup__content popup__content_registration">
                <div className="tabs">
                    {this.renderForm()}
                </div>
                {isDesktop() && <FastRegistrationDescription/>}
            </div>
        </PopupDialog>;
    }
}
